import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskChatRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-chat',
	path: '/jira/servicedesk/projects/:projectKey/settings/chat',
	exact: true,
};
